import { render, staticRenderFns } from "./AppReviewDialog.vue?vue&type=template&id=2581ab27"
import script from "./AppReviewDialog.vue?vue&type=script&lang=js"
export * from "./AppReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports